<template>
  <div id="demo-basic-card">
    <vs-alert v-if="android" class="mt-5 mb-base" color="danger">
      <span class="flex items-center">
        <feather-icon
          icon="InfoIcon"
          svgClasses="h-5 w-4"
          class="mr-2"
        />
        <span>{{$t('The web app is no longer supported on Android devices. Please, use the Android app from: ')}} <a target="blank" href="https://shipblu-ops-android.s3.eu-west-3.amazonaws.com/ShipBlu-Ops.apk">{{$t('this link.')}}</a></span>
      </span>
    </vs-alert>
    <template v-else>
      <div class="mb-base">
        <h2>{{$t('Today')}}</h2>
      </div>
      <div class="vx-row mb-base text-center">
        <div class="vx-col w-1/3 mb-base">
          <img src="../../assets/images/pages/box.png" alt="content-img" class="w-12">
          <p>{{pickups.length}}</p>
          <p>{{$t('Pickups')}}</p>
        </div>
        <div class="vx-col w-1/3 mb-base">
          <img src="../../assets/images/pages/delivery-man.png" alt="content-img" class="w-12">
          <p>{{drops.length}}</p>
          <p>{{$t('Drop Offs')}}</p>
        </div>
        <div @click="confirmCash()" :class="Number(taskSheet.custody_from_khazna) > 0 && taskSheet.custody_status === 'added_by_team_leader' ? 'link cursor-pointer' : ''" class="vx-col w-1/3 mb-base">
          <p class="mt-2 mb-4 font-semibold text-xl">{{$t('EGP')}}</p>
          <p>{{cashCollected}} / {{allCash}}</p>
          <p>{{$t('Cash Collection')}}</p>
        </div>
      </div>
      <!-- Alert if Geolocation is not supported -->
      <div class="vx-row mb-base text-center" v-if="!geoLocationSupported">
        <vs-alert class="mt-5" color="danger">
          <span class="flex items-center">
            <feather-icon
              icon="AlertTriangleIcon"
              svgClasses="h-5 w-4"
              class="mr-2"
            />
            <span>{{$t('Your mobile browser does not support location services!')}}</span>
          </span>
        </vs-alert>
      </div>
      <!-- End Alert -->
      <!-- Alert if Geolocation is supported but user has not allowed it yet -->
      <div class="vx-row mb-base text-center" v-if="geoLocationSupported && !geoLocationPermissionAllowed">
        <vs-alert class="mt-5" color="warning">
          <span class="flex items-center">
            <feather-icon
              icon="AlertTriangleIcon"
              svgClasses="h-5 w-4"
              class="mr-2"
            />
            <span>{{$t('Please, allow location services on your phone!')}}</span>
          </span>
        </vs-alert>
      </div>
      <!-- End Alert -->
      <div class="flex" v-if="taskSheet">
        <vs-button :disabled="taskSheet.custody_status !== 'received_by_agent'" class="mt-5 h-14 rounded-none rounded-l-lg" color="primary" icon-pack="feather" icon="icon-camera" @click="startCam"></vs-button>
        <vs-input :disabled="taskSheet.custody_status !== 'received_by_agent'" v-validate="'numeric'" size="large" name="package" class="scan-input w-full" :label-placeholder="$t('Scan with barcode or click camera')" v-model="packageId" @keyup.enter.native="[packageId? onDecode(packageId): '']" />
      </div>
      <vs-collapse v-if="taskSheet" accordion>
        <vs-collapse-item ref="vsCollapseItem" v-for="shipment in taskSheetOrders" :key="shipment.index">
          <div slot="header">
            <vx-card :style="shipment.status === 'collection_requested' || shipment.status === 'out_for_delivery' || shipment.status === 'return_requested' ?
            'background: #e8f35c69' : shipment.status === 'collected' || shipment.status === 'delivered' || shipment.status === 'picked_up' ||
            ((shipment.tracking_number[0] === '2' || (shipment.tracking_number[0] === '3' && shipment.tracking_number[1] === '2')) && shipment.status === 'in_transit') ?
            'background: rgb(220, 239, 210)' : shipment.status === 'delivery_attempted' || shipment.status === 'collection_attempted' || shipment.status === 'return_attempted' ?
            'background: rgb(254, 172, 174)' : shipment.status === 'in_transit' ? 'background: #e8e5e5': ''">
              <div class="flex">
                <p>{{$t('To')}}: {{shipment.customer.full_name}}</p>
                <p class="text-right ml-auto">{{$t('Zone')}}: {{$t(shipment.customer.address.zone.name)}}</p>
              </div>
              <p>{{$t('Address')}}: {{shipment.customer.address.line_1 + ' ' + shipment.customer.address.line_2}}</p>
              <p>{{$t('Delivery Window')}}: <br/> <span v-for="item in shipment.preferred_window" :key="item.index">{{item.display_name}}<br/> </span></p>
            </vx-card>
          </div>
          <div v-if="shipment.tracking_number[0] === '1'|| (shipment.tracking_number[0] === '3' && shipment.tracking_number[1] === '1')" class="mb-4 p-2" :style="'background: #e8e5e5'">
            <div class="ml-auto mr-auto w-11/12 rounded-lg mb-4 p-2 text-center">
              <vs-button class="w-full" @click="navigateToAddress(shipment)"> {{$t('Navigate')}} </vs-button>
            </div>
            <vx-card class="ml-auto mr-auto w-11/12 rounded-lg mb-4 text-center">
              <h3 class="">{{$t('Address')}}</h3>
              <p class="text-lg">{{shipment.customer.address.line_1 }}<br/>
              {{shipment.customer.address.line_2}}<br/>
              {{shipment.customer.address.line_3}}</p>
            </vx-card>
            <vx-card class="ml-auto mr-auto w-11/12 rounded-lg mb-4 text-center">
              <h3 class="">{{$t('Delivery Notes')}}</h3>
              <p class="text-lg">{{shipment.order_notes}}</p>
            </vx-card>
            <vx-card class="text-center mb-base ml-auto mr-auto w-11/12">
              <div class="vx-row text-center">
                <div :class="parseInt(shipment.cash_amount) > 0 ? 'w-1/2' : 'w-full'">
                  <div class="vx-col" :class="shipment.status === 'delivered' ? 'text-green' : ''">
                    <img :src="shipment.status === 'delivered' ? successBoxImage : boxImage" alt="content-img" class="ml-auto mr-auto w-16">
                    <p class="text-lg font-semibold">{{$t('Service')}}</p>
                    <p class="text-xl font-semibold">{{$t('Delivery Only')}}</p>
                  </div>
                </div>
                <div v-if="parseInt(shipment.cash_amount) > 0" class="vx-col w-1/2 mb-4" :class="shipment.status === 'delivered' ? 'text-green' : ''">
                  <img :src="shipment.status === 'delivered' ? successPayImage : payImage" alt="content-img" class="ml-auto mr-auto w-16">
                  <p class="text-lg font-semibold">{{parseInt(shipment.cash_amount) > 0 ? 'CoD' : 'Online'}}</p>
                  <p class="text-xl font-semibold">{{shipment.cash_amount ? shipment.cash_amount : 'N/A'}}</p>
                </div>
              </div>
              <div v-if="shipment.status === 'in_transit' || shipment.status === 'out_for_delivery'">
                <vs-button color="success" class="mb-4 w-4/5" @click="confirmDelivered(shipment, 'delivered')"> {{parseInt(shipment.cash_amount) > 0 ? $t('PACKAGES DELIVERED & CASH COLLECTED') : $t('PACKAGES DELIVERED')}} ({{shipment.packages.length}}) </vs-button>
                <vs-button color="secondary" class="w-4/5" @click="failedDelivery(shipment)">{{$t('Failed to Deliver')}}</vs-button>
              </div>
              <div v-else>
                <p class="text-xl mb-4" :class="shipment.status === 'picked_up' || shipment.status === 'delivered'? 'text-green' : 'text-danger'">{{ shipment.status === 'delivered'? $t('Thanks For a successful Delivery!') : shipment.status === 'delivery_attempted'? $t('Delivery failed. Thanks for trying.')  : ''}}</p>
              </div>
              <div v-if="failedFlag">
                <div class="mt-5 text-left w-11/12 rounded-lg">
                  <h2 class="mb-5">{{$t('FAILED DELIVERY')}}</h2>
                  <p class="mb-5 text-lg font-medium">{{$t(failedDeliveryQuestion)}}:</p>
                  <ul class="centerx">
                    <li v-for="choose in failedDeliveryAnswersOptions" :key="choose.index">
                      <vs-radio name="reason" v-validate="'required'" v-model="answers.failedDeliveryOption" :vs-value="choose.value">{{$t(choose.text)}}</vs-radio>
                    </li>
                  </ul>
                  <span class="text-danger text-sm" v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
                  <vs-input class="mb-6 w-1/2" :label-placeholder="$t('Comment')" name="comment" v-model="answers.comment"/>
                </div>
                <div class="w-11/12 text-left rounded-lg">
                  <h2 class="mb-5">{{$t('FLEET MANAGER')}}</h2>
                    <p class="mb-5 text-lg font-medium">{{$t(fleetManagerQuestion)}}</p>
                    <ul class="mb-6 centerx">
                      <li>
                        <vs-radio name="fleet manager" v-validate="'required'" v-model="answers.fleetOption" vs-value="yes">{{$t('Yes')}}</vs-radio>
                      </li>
                      <li>
                        <vs-radio name="fleet manager" v-validate="'required'" v-model="answers.fleetOption" vs-value="no">{{$t('NO')}}</vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('fleet manager')">{{ errors.first('fleet manager') }}</span>
                    <vs-input v-validate="'required'" name="explain" class="text-black mb-3 w-full" v-if="answers.fleetOption === 'no'" placeholder="Please explain" v-model="answers.managerNote"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('explain')">{{ errors.first('explain') }}</span>
                    <p class="mb-5 text-lg font-medium">{{$t(approveQuestion)}}</p>
                    <ul class="mb-6 centerx">
                      <li>
                        <vs-radio name="approve" v-validate="'required'" v-model="answers.approveManager" vs-value="Yes approved">{{$t('Yes')}}</vs-radio>
                      </li>
                      <li>
                        <vs-radio name="approve" v-validate="'required'" v-model="answers.approveManager" vs-value="No approve">{{$t('NO')}}</vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('approve')">{{ errors.first('approve') }}</span>
                </div>
                <vs-button @click="reportFailure" color="danger" type="filled" class="m-auto w-11/12 block">{{$t('REPORT FAILURE')}}</vs-button>
              </div>
            </vx-card>
          </div>
          <div v-else-if="shipment.tracking_number[0] === '2' || (shipment.tracking_number[0] === '3' && shipment.tracking_number[1] === '2')">
            <div class="flex" v-if="taskSheet">
              <vs-button class="mt-5 h-14 rounded-none rounded-l-lg" color="primary" icon-pack="feather" icon="icon-camera" @click="startPickupCam"></vs-button>
              <vs-input v-validate="'numeric'" size="large" name="package" class="scan-input w-full" :label-placeholder="$t('Scan with barcode or click camera')" v-model="pickupPackageId" @keyup.enter.native="[pickupPackageId? onDecode(pickupPackageId): '']" />
            </div>
            <div>
              <vx-card class="mb-6"
              :style="shipment.status === 'return_attempted' ? 'background: rgb(254, 172, 174)' : shipment.status === 'picked_up' || shipment.status === 'in_transit' ? 'background: rgb(220, 239, 210)' : ''">
                <p>{{$t('Tracking Number')}}: {{shipment.tracking_number}}</p>
                <vs-divider></vs-divider>
                <div class="vx-row text-center mb-base">
                  <div class="vx-col w-1/3" v-for="item in shipment.packages" :key="item.index">
                    <img class="w-12 ml-auto mr-auto mb-4" src="../../assets/images/pages/box.png"/>
                    <div v-if="shipment.packages" :class="item.scanned ? 'text-green': ''">
                      <p>{{item.package.package_size.short_code}}</p>
                    </div>
                  </div>
                  <div v-if="parseInt(shipment.cash_amount) > 0" class="vx-col mt-4 w-full mb-4" :class="shipment.status === 'picked_up' ? 'text-green' : ''">
                    <img :src="shipment.status === 'picked_up' ? successPayImage : payImage" alt="content-img" class="ml-auto mr-auto w-16">
                    <p class="text-lg font-semibold">{{parseInt(shipment.cash_amount) > 0 ? 'Refund' : 'Online'}}</p>
                    <p class="text-xl font-semibold">{{shipment.cash_amount ? shipment.cash_amount : 'N/A'}}</p>
                  </div>
                </div>
                <div class="text-center">
                  <vs-button color="secondary" v-if="shipment.status !== 'return_attempted' && shipment.status !== 'picked_up' && shipment.status !== 'in_transit'" class="w-4/5" @click="failedReturn(shipment)">{{$t('Failed to Pickup')}}</vs-button>
                </div>
                <div v-if="returnFailedFlag && shipment.status !== 'picked_up' && shipment.status !== 'in_transit'">
                  <div class="mt-5 text-left w-11/12 rounded-lg">
                    <h2 class="mb-5">{{$t('FAILED DELIVERY')}}</h2>
                      <p class="mb-5 text-lg font-medium">{{$t(failedDeliveryQuestion)}}:</p>
                      <ul class="mb-6 centerx">
                        <li v-for="choose in failedDeliveryAnswersOptions" :key="choose.index">
                          <vs-radio name="reason" v-validate="'required'" v-model="answers.failedDeliveryOption" :vs-value="choose.value">{{$t(choose.text)}}</vs-radio>
                        </li>
                      </ul>
                      <span class="text-danger text-sm" v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
                  </div>
                  <div class="w-11/12 text-left rounded-lg">
                    <h2 class="mb-5">{{$t('FLEET MANAGER')}}</h2>
                      <p class="mb-5 text-lg font-medium">{{$t(fleetManagerQuestion)}}</p>
                      <ul class="mb-6 centerx">
                        <li>
                          <vs-radio name="fleet manager" v-validate="'required'" v-model="answers.fleetOption" vs-value="yes">{{$t('Yes')}}</vs-radio>
                        </li>
                        <li>
                          <vs-radio name="fleet manager" v-validate="'required'" v-model="answers.fleetOption" vs-value="no">{{$t('NO')}}</vs-radio>
                        </li>
                      </ul>
                      <span class="text-danger text-sm" v-show="errors.has('fleet manager')">{{ errors.first('fleet manager') }}</span>
                      <vs-input v-validate="'required'" name="explain" class="text-black mb-3 w-full" v-if="answers.fleetOption === 'no'" placeholder="Please explain" v-model="answers.managerNote"></vs-input>
                      <span class="text-danger text-sm" v-show="errors.has('explain')">{{ errors.first('explain') }}</span>
                      <p class="mb-5 text-lg font-medium">{{$t(approveQuestion)}}</p>
                      <ul class="mb-6 centerx">
                        <li>
                          <vs-radio name="approve" v-validate="'required'" v-model="answers.approveManager" vs-value="Yes approved">{{$t('Yes')}}</vs-radio>
                        </li>
                        <li>
                          <vs-radio name="approve" v-validate="'required'" v-model="answers.approveManager" vs-value="No approve">{{$t('NO')}}</vs-radio>
                        </li>
                      </ul>
                      <span class="text-danger text-sm" v-show="errors.has('approve')">{{ errors.first('approve') }}</span>
                  </div>
                  <vs-button @click="reportFailure" color="danger" type="filled" class="w-11/12 block">{{$t('REPORT FAILURE')}}</vs-button>
                </div>
              </vx-card>
            </div>
          </div>
          
          <div v-if="shipment.tracking_number[0] === '4'" class="mb-4 p-2" :style="'background: #e8e5e5'">
            <div class="ml-auto mr-auto w-11/12 rounded-lg mb-4 p-2 text-center">
              <vs-button class="w-full" @click="navigateToAddress(shipment)"> {{$t('Navigate')}} </vs-button>
            </div>
            <vx-card class="ml-auto mr-auto w-11/12 rounded-lg mb-4 text-center">
              <h3 class="">{{$t('Address')}}</h3>
              <p class="text-lg">{{shipment.customer.address.line_1 }}<br/>
              {{shipment.customer.address.line_2}}<br/>
              {{shipment.customer.address.line_3}}</p>
            </vx-card>
            <vx-card class="text-center mb-base ml-auto mr-auto w-11/12">
              <div class="vx-row text-center">
                <div :class="parseInt(shipment.cash_amount) > 0 ? 'w-1/2' : 'w-full'">
                  <div class="vx-col" :class="shipment.status === 'collected' ? 'text-green' : ''">
                    <img :src="shipment.status === 'collected' ? successPayImage : payImage " alt="content-img" class="ml-auto mr-auto w-16">
                    <p class="text-lg font-semibold">{{$t('Cash Collection')}}</p>
                    <p class="text-xl font-semibold">{{shipment.amount}}</p>
                  </div>
                </div>
              </div>
              <div v-if="shipment.status === 'collection_requested'">
                <vs-button color="success" class="mb-4 w-4/5" @click="updateShipment(shipment, 'collected')"> {{$t('CASH COLLECTED')}} </vs-button>
                <vs-button color="secondary" class="w-4/5" @click="failedDelivery(shipment)">{{$t('Failed to Deliver')}}</vs-button>
              </div>
              <div v-else>
                <p class="text-xl mb-4" :class="shipment.status === 'collected'? 'text-green' : 'text-danger'">{{ shipment.status === 'collected'? $t('Thanks For a successful Cash Collection!') : shipment.status === 'collection_attempted'? $t('Cash Collection failed. Thanks for trying.')  : ''}}</p>
              </div>
              <div v-if="failedFlag">
                <div class="mt-5 text-left w-11/12 rounded-lg">
                  <h2 class="mb-5">{{$t('FAILED DELIVERY')}}</h2>
                    <p class="mb-5 text-lg font-medium">{{$t(failedDeliveryQuestion)}}:</p>
                    <ul class="mb-6 centerx">
                      <li v-for="choose in failedDeliveryAnswersOptions" :key="choose.index">
                        <vs-radio name="reason" v-validate="'required'" v-model="answers.failedDeliveryOption" :vs-value="choose.value">{{$t(choose.text)}}</vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
                </div>
                <div class="w-11/12 text-left rounded-lg">
                  <h2 class="mb-5">{{$t('FLEET MANAGER')}}</h2>
                    <p class="mb-5 text-lg font-medium">{{$t(fleetManagerQuestion)}}</p>
                    <ul class="mb-6 centerx">
                      <li>
                        <vs-radio name="fleet manager" v-validate="'required'" v-model="answers.fleetOption" vs-value="yes">{{$t('Yes')}}</vs-radio>
                      </li>
                      <li>
                        <vs-radio name="fleet manager" v-validate="'required'" v-model="answers.fleetOption" vs-value="no">{{$t('NO')}}</vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('fleet manager')">{{ errors.first('fleet manager') }}</span>
                    <vs-input v-validate="'required'" name="explain" class="text-black mb-3 w-full" v-if="answers.fleetOption === 'no'" placeholder="Please explain" v-model="answers.managerNote"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('explain')">{{ errors.first('explain') }}</span>
                    <p class="mb-5 text-lg font-medium">{{$t(approveQuestion)}}</p>
                    <ul class="mb-6 centerx">
                      <li>
                        <vs-radio name="approve" v-validate="'required'" v-model="answers.approveManager" vs-value="Yes approved">{{$t('Yes')}}</vs-radio>
                      </li>
                      <li>
                        <vs-radio name="approve" v-validate="'required'" v-model="answers.approveManager" vs-value="No approve">{{$t('NO')}}</vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('approve')">{{ errors.first('approve') }}</span>
                </div>
                <vs-button @click="reportFailure" color="danger" type="filled" class="w-11/12 block">{{$t('REPORT FAILURE')}}</vs-button>
              </div>
            </vx-card>
          </div>
        </vs-collapse-item>
      </vs-collapse>
      <template v-if="taskSheet">
      <vs-button @click="loadTaskSheetOrders" class="text-xl mb-4 font-semibold w-full rounded-lg">
          <feather-icon
            icon="RotateCwIcon"
            svgClasses="h-4 w-4"
            class="mr-2"
          />
        </vs-button>
      <vs-button @click="updateTaskSheet('completed')" :disabled="!endDayFlag" class="text-xl font-semibold w-full rounded-lg">{{$t('END DAY!')}}</vs-button>
      </template>
    </template>
  </div>
</template>

<script>
import AXIOS from '../../axios'
import {sendRequest} from '../../http/axios/requestHelper.js'
import i18nData from '../../i18n/i18nData'
import boxImage from '../../assets/images/pages/box.png'
import successBoxImage from '../../assets/images/pages/box-green.png'
import payImage from '../../assets/images/pages/pay.png'
import successPayImage from '../../assets/images/pages/pay-green.png'
import common  from '@/assets/utils/common'

export default {
  data () {
    return {
      boxImage,
      payImage,
      successBoxImage,
      successPayImage,
      allCash: 0,
      taskSheet: '',
      pickups: [],
      drops: [],
      warehouse: {},
      endDayFlag: false,
      startedCamera: false,
      packageId: '',
      failedFlag: false,
      returnFailedFlag: false,
      taskSheetOrders: [],
      pickupPackageId: '',
      startedPickupCamera: false,
      ordersPackages: [],
      packagesInOrder: [],
      cashCollected: 0,
      failedOrder: {},
      failedDeliveryQuestion: 'Choose reason for failed delivery',
      fleetManagerQuestion: 'Have you notified your manager?',
      approveQuestion: 'Have you received approval to fail delivery from your manager?',
      failedDeliveryAnswersOptions: [
        {
          text: 'Customer\'s phone is turned off',
          value: 'Customer\'s phone is turned off'
        },
        {
          text: 'Customer is not answering the phone',
          value: 'Customer is not answering the phone'
        },
        {
          text: 'Phone Number is not related to the customer',
          value: 'Phone Number is not related to the customer'
        },
        {
          text: 'Wrong address provided',
          value: 'Wrong address provided'
        },
        {
          text: 'Address not completed',
          value: 'Address not completed'
        },
        {
          text: 'No one at home',
          value: 'No one at home'
        },
        {
          text: 'Customer rescheduled',
          value: 'Customer rescheduled'
        },
        {
          text: 'Customer request to change address',
          value: 'Customer request to change address'
        },
        {
          text: 'Customer refused to accept delivery',
          value: 'Customer refused to accept delivery'
        },
        {
          text: 'Customer didn\'t have Money',
          value: 'Customer didn\'t have Money'
        },
        {
          text: 'Customer evade to receive',
          value: 'Customer evade to receive'
        },
        {
          text: 'Customer Wants to open the package',
          value: 'Customer Wants to open the package'
        }
      ],
      answers: {
        failedDeliveryOption: '',
        fleetOption: '',
        approveManager: '',
        managerNote: '',
        comment: ''
      },
      geoLocationSupported: true,
      geoLocationPermissionAllowed: true,
      locationTrackingSessionId: '',
      locationTrackingSocket: {},
      agentID: '',
      orderData: {},
      updateStatus: '',
      android: false
    }
  },
  methods: {
    startCam () {
      this.startedCamera = !this.startedCamera
      this.onDecode()
    },
    startPickupCam () {
      this.startedPickupCamera = !this.startedPickupCamera
      this.onDecode()
    },
    onDecode (result) {
      if (result !== undefined) {
        if (this.startedCamera) {
          this.startedCamera = !this.startedCamera
        }
        this.packageId = ''
        this.pickupPackageId = ''
        this.taskSheetOrders.map(element => {
          if (element.packages) {
            element.packages.map(item => {
              if (item.packageId === result) {
                this.$vs.notify({
                  color:'success',
                  title:i18nData[this.$i18n.locale]['Success'],
                  text: 'This package is scanned successfully',
                  position: 'top-center'
                })
                item.scanned = 'scanned'
                this.packagesInOrder = this.ordersPackages.filter(element => element.orderId === item.orderId)
              }
            })
          }
        })
        if (this.packagesInOrder.length > 0) {
          if (this.packagesInOrder.every(scan => scan.scanned === 'scanned')) {
            this.updateDropOffStatus(this.packagesInOrder[0], this.packagesInOrder[0].tracking[0] === '1' || (this.packagesInOrder[0].tracking[0] === '3' &&  this.packagesInOrder[0].tracking[1] === '1') ? 'out_for_delivery' : 'picked_up')
          }
        }
      }
    },
    navigateToAddress (item) {
      if (item.customer.address.lat && item.customer.address.long) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${item.customer.address.lat},${item.customer.address.long}`, '_blank')
      } else if (item.customer.address.line_1) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${item.customer.address.line_1}`, '_blank')
      }
    },
    updateDropOffStatus (item, status) {
      const trackings = []
      this.$vs.loading()
      trackings.push({
        order: item.orderId,
        status
      })
      sendRequest(false, this, 'api/v1/tracking/', 'post', trackings, true,
        () => {
          this.taskSheetOrders.forEach(element => {
            if (element.id === item.orderId) {
              element.status = status
            }
          })
          if (status === 'out_for_delivery') {
            this.emptyFromSlot(item)
          } else if (status === 'picked_up') {
            this.cashCollected = this.cashCollected - item.cash_amount
          }
        }
      )
    },
    emptyFromSlot (order) {
      if (order.package_location.id) {
        sendRequest(false, this, `api/v1/warehousing/slots/${order.package_location.id}/empty/`, 'post', {}, true,
          {}
        )
      }
    },
    loadTaskSheetOrders () {
      sendRequest(false, this, 'api/v1/task-sheets/', 'get', null, true,
        (response) => {
          if (response.data.task_sheet) {
            this.drops = []
            this.pickups = []
            this.taskSheetOrders = []
            this.allCash = 0
            this.cashCollected = 0
            this.taskSheet = response.data
            if (response.data.id && this.taskSheet.status !== 'completed') {
              this.updateTaskSheet('in_progress')
            }
            if (response.data.task_sheet.length > 0) {
              response.data.task_sheet.map(element => {
                if (element.order) {
                  element.order.sequence = element.sequence
                  this.taskSheetOrders.push(element.order)
                } else {
                  element.cash_collection.sequence = element.sequence
                  this.taskSheetOrders.push(element.cash_collection)
                }
              })
              // Sort Task Sheet Orders BY SEQUENCE
              this.taskSheetOrders.sort(function (order, secondOrder) { return order.sequence - secondOrder.sequence })

              //add Local State to PACKAGES
              this.taskSheetOrders.forEach(element => {
                if (element.tracking_number[0] !== '4') {
                  element.packages.map(item => {
                    item.scanned = ''
                    item.tracking = element.tracking_number
                    item.orderId = element.id
                    item.cash_amount = element.cash_amount
                    item.packageId = element.tracking_number[0] === '1' || (element.tracking_number[0] === '3' && element.tracking_number[1] === '1') ? `1${item.package.id}` : `2${item.package.id}`
                  })
                }
                
                if (element.tracking_number[0] === '1' || (element.tracking_number[0] === '3' && element.tracking_number[1] === '1')) {
                  this.drops.push(element)
                } else if (element.tracking_number[0] === '2') {
                  this.pickups.push(element)
                }
              })
              this.taskSheetOrders.forEach(element => {
                if ((element.tracking_number[0] === '1' || (element.tracking_number[0] === '3' && element.tracking_number[1] === '1')) && parseInt(element.cash_amount) > 0) {
                  this.allCash = this.allCash + element.cash_amount
                  if (element.status === 'delivered') {
                    this.cashCollected = this.cashCollected + element.cash_amount
                  }
                } else if (element.tracking_number[0] === '4') {
                  this.allCash = this.allCash + element.amount
                  if (element.status === 'collected') {
                    this.cashCollected = this.cashCollected + element.amount
                  }
                } else if (element.tracking_number[0] === '2' || (element.tracking_number[0] === '3' && element.tracking_number[1] === '2')) {
                  if (element.status === 'in_transit' || element.status === 'picked_up') {
                    this.cashCollected = this.cashCollected - element.cash_amount
                  }
                }
              })
              this.cashCollected += this.taskSheet.custody_status === 'received_by_agent' ? Number(this.taskSheet.custody_from_khazna) : 0
              this.ordersPackages = this.taskSheetOrders.map(item => item.packages).flat().filter(element => element !== undefined)
              this.disableEndDay()
            } else {
              this.taskSheet = ''
            }

            // Create a location tracking session (if not exists)
            this.agentID = this.taskSheet.id + this.$store.state.AppActiveUser.email.substr(0, 5)
            if (this.taskSheet.live_tracking_link === '' || this.taskSheet.live_tracking_link === null) {
              const agentName = this.$store.state.AppActiveUser.displayName
              this.createTrackingSession(agentName, this.agentID)
            } else {
              // Just to make sure we connect to the web socket again
              this.locationTrackingSocket = new WebSocket(
                `wss://live.shipblu.com/agent/${this.agentID}/track/`)
              this.locationTrackingSocket.onclose = () => {
                this.locationTrackingSocket = {}
              }
            }
            // After the socket initialized, get agent location every 10 seconds
            this.getAgentLocation()
            setInterval(function () {
              this.getAgentLocation()
            }.bind(this), 5000)
          } else {
            this.taskSheet = ''
            this.drops = []
            this.pickups = []
            this.allCash = 0
            this.cashCollected = 0
          }
        }
      )
    },
    disableEndDay () {
      const ordersStatus = this.taskSheetOrders.map(elements => elements.status === 'in_transit' || elements.status === 'delivered' || elements.status === 'collection_attempted' || elements.status === 'collected' || elements.status === 'return_requested' || elements.status === 'return_attempted' || elements.status === 'returned')
      if (ordersStatus.every(status => status === true)) {
        if (this.taskSheet.task_sheet_cash_collected) {
          this.endDayFlag = true
        } else {
          this.endDayFlag = false
        }
      }
    },
    reportFailure () {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.updateShipment(this.failedOrder, this.failedOrder.tracking_number[0] === '1' || (this.failedOrder.tracking_number[0] === '3' && this.failedOrder.tracking_number[1] === '1') ? 'delivery_attempted' : this.failedOrder.tracking_number[0] === '4' ?  'collection_attempted' : 'return_attempted')
        }
      })
    },
    updateTaskSheet (status) {
      sendRequest(false, this, `api/v1/task-sheets/${this.taskSheet.id}/`, 'patch', {status}, true,
        () => {
          if (status === 'completed') {
            this.deleteTrackingSession(this.agentID)
            this.taskSheet = ''
            this.$vs.notify({
              color:'success',
              title:i18nData[this.$i18n.locale]['Success'],
              text: 'Task sheet has been completed successfully',
              position: 'top-center'
            })
            this.drops = []
            this.pickups = []
            this.allCash = 0
            this.cashCollected = 0
          }
        }
      )
    },
    failedDelivery (data) {
      this.failedFlag = !this.failedFlag
      this.failedOrder = data
    },
    failedReturn (data) {
      this.returnFailedFlag = !this.returnFailedFlag
      this.failedOrder = data
    },
    updateCashCollection (cashCollection) {
      sendRequest(false, this, `api/v1/cash-collections/${cashCollection.cash_collection.id}/`, 'post', {status: 'collected'}, true,
        () => {
          this.cashCollected = this.cashCollected + cashCollection.cash_collection.amount
        }
      )
    },
    confirmDelivered (data, status) {
      this.orderData = data
      this.updateStatus = status
      this.$vs.dialog({
        color: 'success',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Confirm delivery?'],
        accept: this.updateShipment
      })
    },
    updateShipment (shipment, status) {
      if (this.orderData.id) {
        shipment = this.orderData
        status = this.updateStatus
      }
      const trackings = []
      let url = ''
      if (status === 'collected' || status === 'collection_attempted') {
        url = 'api/v1/tracking/cash-collections/'
        trackings.push({
          cash_collection_request: shipment.id,
          status,
          attempt_questions: []
        })
      } else if (status === 'delivered' || status === 'delivery_attempted' || status === 'return_attempted') {
        url = 'api/v1/tracking/'
        trackings.push({
          order: shipment.id,
          status,
          attempt_questions: []
        })
      }
      if (status === 'delivery_attempted' || status === 'collection_attempted' || status === 'return_attempted') {
        trackings[0].attempt_questions = [
          {
            question: this.failedDeliveryQuestion,
            answer: `${this.answers.failedDeliveryOption}${this.answers.comment ? ` - ${this.answers.comment}` : '' }`
          },
          {
            question: this.fleetManagerQuestion,
            answer: this.answers.fleetOption
          },
          {
            question: this.approveQuestion,
            answer: this.answers.approveManager
          }
        ]
      }
      sendRequest(false, this, url, 'post', trackings, true,
        () => {
          if (this.orderData.id) {
            this.orderData = {}
          }
          this.failedFlag = false
          this.returnFailedFlag = false
          shipment.status = status
          if (status === 'delivered' && parseInt(shipment.cash_amount) > 0) {
            this.cashCollected = this.cashCollected + shipment.cash_amount
          } else if (status === 'collected') {
            this.cashCollected = this.cashCollected + shipment.amount
          }
        }
      )
    },
    loadCustomerAgent () {
      sendRequest(false, this, `api/v1/users/customer-agents/${this.$store.state.AppActiveUser.uid}/`, 'get', null, true,
        (response) => {
          this.warehouse = response.data.primary_warehouse
        }
      )
    },
    isGeoLocationSupported () {
      if (!navigator.geolocation) {
        this.geoLocationSupported = false
      }
    },
    createTrackingSession (agentName, agentId) {
      // TODO: Axios probably has some base URL that might make this not work
      AXIOS.post('https://live.shipblu.com/agent/', {'agent_name': agentName, 'agent_id': agentId}, {})
        .then((response) => {
          this.locationTrackingSessionId = response.data.agent_id
          this.locationTrackingSocket = new WebSocket(
            `wss://live.shipblu.com/agent/${this.locationTrackingSessionId}/track/`)
          this.locationTrackingSocket.onclose = () => {
            this.locationTrackingSocket = {}
          }
          this.updateLiveTrackingLink(`https://live.shipblu.com/${this.locationTrackingSessionId}/`)
        }).catch((error) => {
          common.notifyResponseError(this, error)
        })
    },
    deleteTrackingSession (agentId) {
      // TODO: This should be called when after the day is ended.
      // TODO: Axios probably has some base URL that might make this not work
      AXIOS.delete(`https://live.shipblu.com/agent/${agentId}/`)
    },
    updateLiveTrackingLink (live_tracking_link) {
      sendRequest(false, this, `api/v1/task-sheets/${this.taskSheet.id}/`, 'patch', {live_tracking_link}, true,
        () => {
          this.taskSheet.live_tracking_link = live_tracking_link
        }
      )
    },
    getAgentLocation () {
      navigator.geolocation.getCurrentPosition(this.onLocationQuerySuccess, this.onLocationQueryFail)
    },
    onLocationQuerySuccess (position) {
      const {
        latitude,
        longitude
      } = position.coords
      if (!this.locationTrackingSocket) {
        this.locationTrackingSocket = new WebSocket(
          `wss://live.shipblu.com/agent/${this.locationTrackingSessionId}/track/`)
        this.locationTrackingSocket.onclose = () => {
          this.locationTrackingSocket = {}
        }
      }
      if (this.locationTrackingSocket.readyState === WebSocket.OPEN) {
        this.locationTrackingSocket.send(
          JSON.stringify({latitude, longitude})
        )
      }
    },
    onLocationQueryFail () {
      this.geoLocationPermissionAllowed = false
    },
    confirmCash () {
      if (this.taskSheet.custody_status !== 'received_by_agent') {
        this.confirmMessage()
      }
    },
    confirmMessage () {
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: `${i18nData[this.$i18n.locale]['Are you sure to receive'] + this.taskSheet.custody_from_khazna + i18nData[this.$i18n.locale]['EGP']}!`,
        accept: this.updateCustody
      })
    },
    updateCustody () {
      sendRequest(false, this, `api/v1/task-sheets/${this.taskSheet.id}/`, 'patch', {custody_status: 'received_by_agent'}, true,
        () => {
          this.taskSheet.custody_status = 'received_by_agent'
          this.cashCollected += this.taskSheet.custody_from_khazna
        }
      )
    },
    detectAppleDevices () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  beforeDestroy () {
    if (this.$refs.vsCollapseItem) {
      for (const collapseItem of this.$refs.vsCollapseItem) {
        window.removeEventListener('resize', collapseItem)
      }
    }
  },
  created () {
    if (/(android)/i.test(navigator.userAgent) || this.detectAppleDevices()) {
      this.android = true
    } else {
      this.android = false
      this.loadCustomerAgent()
      this.loadTaskSheetOrders()
      // Gelocation
      this.isGeoLocationSupported()
    }
    
  }
}
</script>
<style scoped>
.card-img-top {
  height: 350px;
}
</style>
<style>
.vs-collapse-item--icon-header {
  margin-top: 21px !important;
  margin-left: 31px !important;
}
.vs-collapse-item--icon-header > i {
  font-size: 30px;
}
.open-item .vs-collapse-item--content {
  max-height: fit-content !important;
}
.link {
  text-decoration: underline;
  color: #1c5bfe
}
</style>
